//Accounting
const ChargeAccountModule = () => import('@pages/accounting/ChargeAccountModule.vue')
const ChargeAccountIndex = () => import('@pages/accounting/ChargeAccountIndex.vue')
const ChargeAccountDistribution = () => import('@pages/accounting/ChargeAccountDistribution.vue')

const UserAccountStatementIndex = () => import('@pages/accounting/UserAccountStatementIndex.vue')
const AdminAccountStatementIndex = () => import('@pages/accounting/AdminAccountStatementIndex.vue')

const BillsModule = () => import('@pages/accounting/BillsModule.vue')
const BillsMassiveUpload = () => import('@pages/accounting/BillsMassiveUpload.vue')
const BillsDistribution = () => import('@pages/accounting/BillsDistribution.vue')
const StructureBillsIndex = () => import('@pages/accounting/InternalBills/Index.vue')
const AdminUploadBills = () => import('@pages/accounting/AdminUploadBills.vue')
const AdminBillsDistribution = () => import('@pages/accounting/Administrators/AdminBillsDistribution.vue')

export default {
    path: 'accounting',
    component: ChargeAccountModule,
    children: [
        {
            path: 'admin-upload-bills',
            component: AdminUploadBills,
            name: 'adminUploadBills',
        },
        {
            path: 'admin-bills-distribution',
            component: AdminBillsDistribution,
            name: 'adminBillsDistribution',
        },
        {
            path: 'admon-bills',
            component: AdminAccountStatementIndex,
            name: 'admonBills',
        },
        {
            path: 'charge-account-distribution',
            component: ChargeAccountDistribution,
            name: 'chargeAccountDistribution',
        },
        {
            path: 'admin-account-statement',
            component: AdminAccountStatementIndex,
            name: 'adminStatesAccounts',
        },
        {
            path: 'user-account-statement',
            component: StructureBillsIndex,
            name: 'userAccountStatement',
        },
        {
            path: 'bills',
            component: BillsModule,
            children: [
                {
                    path: 'massive-upload',
                    component: BillsMassiveUpload,
                    name: 'billsMassiveUpload',
                },
                {
                    path: 'distribution',
                    component: BillsDistribution,
                    name: 'billsDistribution',
                },
            ],
        },
        {
            path: 'payment-receipts',
            component: () => import('@pages/accounting/paymentReceipts/PaymentReceiptsModule.vue'),
            children: [
                {
                    path: '/',
                    component: () => import('@pages/accounting/paymentReceipts/PaymentReceiptsIndex.vue'),
                    name: 'paymentReceiptsIndex',
                },
            ],
        },
    ],
}
